import React from 'react';
import { motion } from 'framer-motion';
import MenuItem from './MenuItem';

export default function MenuCategory({ title, items }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="relative p-6 bg-[#FDF6E9] vintage-overlay rounded-lg shadow-xl"
    >
      <div className="relative">
        {/* Vintage header decoration */}
        <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-32 h-1 bg-red-700/20" />
        
        <h3 className="text-2xl font-bold text-red-700 text-center mb-6 retro-text">
          {title}
        </h3>
        
        <div className="space-y-4">
          {items.map((item, index) => (
            <MenuItem
              key={`${item.name}-${index}`}
              name={item.name}
              price={item.price}
            />
          ))}
        </div>
      </div>
    </motion.div>
  );
}